// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"400":"22a70174182afefb","489":"472b452933a8f2d1","883":"c6ec0d8fc24288c8"}[chunkId] + ".js";
};